// src/analytics/analytics.js
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_ID;

let gaInitialized = false;

export function initGA() {
  if (gaInitialized) return;

  if (!GA_MEASUREMENT_ID) {
    console.warn("[GA] Chưa cấu hình GA_MEASUREMENT_ID. Bỏ qua khởi tạo.");
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];

  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());

  window.gtag("config", GA_MEASUREMENT_ID, {
    send_page_view: true,
  });

  gaInitialized = true;
}

function sendEvent(eventName, params = {}) {
  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }
}

export function getDeviceType() {
  const ua = navigator.userAgent;

  if (/android/i.test(ua)) return "android";
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";

  return "desktop";
}

export function trackPage(page) {
  sendEvent("page_view_custom", {
    page,
    device_type: getDeviceType(),
  });
}

export function trackDownload(platform, method) {
  sendEvent("download_click", {
    platform,
    method,
    device_type: getDeviceType(),
  });
}

export function trackSocial(network) {
  sendEvent("social_click", {
    network,
    device_type: getDeviceType(),
  });
}

export function trackGuide(platform) {
  sendEvent("install_guide_click", {
    platform,
    device_type: getDeviceType(),
  });
}

export function trackInstallFlow(platform, action, tab) {
  sendEvent("install_flow", {
    platform,
    action,
    tab,
    device_type: getDeviceType(),
  });
}

const analytics = {
  initGA,
  getDeviceType,
  trackPage,
  trackDownload,
  trackSocial,
  trackGuide,
  trackInstallFlow,
};

export default analytics;
